export const categoryOptions = [
    {text: 'Drinks', value: 'drinks'},
    {text: 'Culture', value: 'culture'},
    {text: 'Film', value: 'film'},
    {text: 'Food', value: 'food'},
    {text: 'Music', value: 'music'},
    {text: 'Travel', value: 'travel'},
]

export const serviceCategoryOptions = [
    {text: 'Get Started Today', value: 'Get Started Today'},
    {text: 'Basic Website Development', value: 'Basic Website Development'},
    {text: 'Dynamic Website Development', value: 'Dynamic Website Development'},
    {text: 'Custom Website Development', value: 'Custom Website Development'},
    {text: 'Web Application Development', value: 'Web Application Development'},
    {text: 'Logo Design', value: 'Logo Design'},
    {text: 'Mobile App Development', value: 'Mobile App Development'},
    {text: 'Hotel Management', value: 'Hotel Management'},
    {text: 'Restaurant Management', value: 'Restaurant Management'},
    {text: 'Store Management', value: 'Store Management'},
    {text: 'Office Management', value: 'Office Management'},
    {text: 'Dairy Management', value: 'Dairy Management'}
]
export const contactMode = [
    {text: 'Phone', value: 'Phone'},
    {text: 'WhatsApp', value: 'WhatsApp'}
]